import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';

const db = getFirestore();
const SECRET_KEY = 'plantao-facil-receita-medica-digital'; // Uma chave secreta que só o seu sistema conhece

export async function gerarCodigo(uid) {
  try {
    const userRef = doc(db, 'users', uid);
    const userDoc = await getDoc(userRef);

    if (userDoc.exists()) {
      const { nome, titulo } = userDoc.data();

      // Gera um código único baseado em UUID, nome, título e uma chave secreta
      const uuid = uuidv4(); // Gera um UUID único
      const timestamp = new Date();
      const codeData = `${uuid}-${nome}-${titulo}-${timestamp.getTime()}-${SECRET_KEY}`;

      const hash = btoa(codeData)
        .replace(/[^A-Z0-9]/gi, '')
        .substring(0, 5)
        .toUpperCase();

      // Formata a data de criação
      const dataCriacao = timestamp.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });

      // Persiste a receita no Firestore com o token gerado
      const receitaRef = doc(db, 'receitasDigitalGeradas', hash);
      await setDoc(receitaRef, {
        userId: uid, // UID do usuário autenticado
        nomeMedico: nome,
        tituloMedico: titulo,
        token: hash,
        dataCriacao: dataCriacao, // Salva a data formatada
      });

      return hash; // Retorna os primeiros 5 caracteres do hash
    } else {
      throw new Error('Usuário não encontrado');
    }
  } catch (error) {
    console.error('Erro ao gerar código:', error);
    throw error;
  }
}

export async function validateCode(token) {
  try {
    const receitaRef = doc(db, 'receitasDigitalGeradas', token);
    const receitaDoc = await getDoc(receitaRef);

    if (receitaDoc.exists()) {
      return receitaDoc.data(); // Retorna os dados da receita se o token for válido
    } else {
      throw new Error('Token inválido ou receita não encontrada.');
    }
  } catch (error) {
    console.error('Erro ao validar código:', error);
    return false;
  }
}
